import { gql } from '@apollo/client';

export const getAdmin = gql`query getAdmin($referenceId: String!) {
      getAdmin(
          referenceId: $referenceId
      ) {
          id
          avatar
          name
          email
          phone
          phoneExt
          signature
          emailName
      }

}`
